import { Card } from '@mui/material';
import type { ReactNode } from 'react';

const FILLED_HEIGHT_PX = 760;

interface TablesSectionCardProps {
  children: ReactNode;
  fillHeight?: boolean;
}

// Outlined card used by the Tables section.
export const TablesSectionCard = ({ children, fillHeight = false }: TablesSectionCardProps) => (
  <Card
    variant="outlined"
    sx={{
      p: 4,
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 0,
      flexShrink: 0,
      ...(fillHeight ? { height: FILLED_HEIGHT_PX } : {}),
    }}
  >
    {children}
  </Card>
);
